import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/common/login'
import sso from '@/views/common/sso'
import ssoGetCode from '@/views/common/ssoGetCode'
import Index from '@/views/common/index'
import questionRecord from '@/views/services/questionRecord.vue'
import PersonSend from '@/views/services/personsend'
import Label from '@/views/services/label'
import config from '@/views/services/globaconfig'
import hotquestion from '@/views/services/hotquestion'
import qadialog from '@/views/services/qadialog'
import unknowQa from '@/views/services/unknowQa'
import qatotal from '@/views/services/questiontotal'
Vue.use(Router)
var a = '/personsend'
export default new Router({

  routes: [
    {
      path: '/',
      name: 'qadialog',
      component: qadialog
    },
    {
      path: '/ssoGetCode',
      name: 'ssoGetCode',
      component: ssoGetCode
    },
    {
      path: '/sso',
      name: 'sso',
      component: sso
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta: {
        requireAuth: true // 判断是否需要登录
      },
      children: [
        {
          path: '/questionRecord',
          name: 'questionRecord',
          component: questionRecord,
          meta: {
            requireAuth: true // 判断是否需要登录
          }
        },
        {
          path: '/label',
          name: 'Label',
          component: Label,
          meta: {
            requireAuth: true // 判断是否需要登录
          }
        },
        {
          path: '/personsend',
          name: 'PersonSend',
          component: PersonSend,
          meta: {
            requireAuth: true // 判断是否需要登录
          }
        },
        {
          path: '/config',
          name: 'config',
          component: config,
          meta: {
            requireAuth: true // 判断是否需要登录
          }
        },
        {
          path: '/hotquestion',
          name: 'hotquestion',
          component: hotquestion,
          meta: {
            requireAuth: true // 判断是否需要登录
          }
        },
        {
          path: '/unknowQa',
          name: 'unknowQa',
          component: unknowQa,
          meta: {
            requireAuth: true // 判断是否需要登录
          }
        },
        {
          path: '/qatotal',
          name: 'qatotal',
          component: qatotal,
          meta: {
            requireAuth: true // 判断是否需要登录
          }
        }
      ]
    }, {
      path: '/qadialog',
      name: 'qadialog',
      component: qadialog,
      meta: {
        requireAuth: false // 判断是否需要登录
      }
    },
    {
      path: '/loginQaManager',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js